import {insertScript} from '../shared/script';
import {deferredValue} from '../shared/util';

export type FB = any;

export interface LoginStatus {
  authResponse?: AuthResponse;
  status: string;
}

export interface AuthResponse {
  accessToken: string;
  userID: string;
  expiresIn: number;
  signedRequest: string;
}

const libValue = deferredValue(() => new Promise<FB>(resolve => {
  (window as any).fbAsyncInit = () => resolve((window as any).FB);

  insertScript({
    src: 'https://connect.facebook.net/en_US/sdk.js',
    id: 'facebook-jssdk',
    async: true,
    defer: true,
  });
}));

export const facebookApi = {
  get fb() {
    return libValue();
  },
  graph(...args: any[]): Promise<any> {
    return new Promise(async resolve => (await facebookApi.fb).api(...args, resolve));
  },
  loginStatus(force = false): Promise<LoginStatus> {
    return new Promise(async resolve => (await facebookApi.fb).getLoginStatus(resolve, force));
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/core/facebook-api.ts